module.exports = __webpack_public_path__ + "static/media/wheelybugs.840586f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wheelybugs.jpg
// module id = 115
// module chunks = 0